import { createRoot } from 'react-dom/client';

// Sentry
import { initSentry } from './sentry';

// CSS
import './css/bootstrap.5.3.2.min.css';
import './css/style.css';
import './css/datepicker.css';

// JS
import Main from './main.js';

// Ikonipaketti
import { library } from '@fortawesome/fontawesome-svg-core';
import {
    faHome,
    faSpinner,
    faFileInvoice,
    faCheckCircle,
    faTimesCircle,
    faChevronDown,
    faEnvelope,
    faPowerOff,
    faSearch,
    faHandHoldingUsd,
    faEllipsisV,
    faEuroSign,
    faPencilAlt,
    faCalendarCheck,
    faCalendarAlt,
    faCalendar,
    faDownload,
    faBars,
    faInfoCircle,
    faFrown,
    faFileSignature,
    faExclamationCircle,
    faArrowLeft,
    faClockRotateLeft,
    faChevronRight
} from '@fortawesome/pro-regular-svg-icons';

library.add(faHome, faFileInvoice, faSpinner, faCheckCircle, faTimesCircle, faChevronDown, faEnvelope, faPowerOff, faSearch, faHandHoldingUsd, faEllipsisV, faEuroSign, faPencilAlt, faCalendarCheck, faCalendarAlt, faCalendar, faDownload, faBars, faInfoCircle, faFrown, faFileSignature, faExclamationCircle, faArrowLeft, faClockRotateLeft, faChevronRight);

/**
 * Migrate URL hash routes to clean URLs, as long as the
 * migration period for url's after react-router-dom upgrade is ongoing.
 */
(function migrateHashToCleanUrl() {
    if (window.location.hash && window.location.hash.startsWith('#/')) {
        // remove the leading '#' and split off query params
        const hashPathWithQuery = window.location.hash.slice(1); // e.g. /#/job -> /job
        const [hashPath, ...rest] = hashPathWithQuery.split('?');
        const query = rest.length ? '?' + rest.join('?') : '';

        // migrate only if the route is recongnized
        const allowedRouteRegex = new RegExp(
            '^(' +
            [
                '/job(\\/.*)?',
                '/jobsearch(\\/.*)?',
                '/login(\\/.*)?',
                '/logout(\\/.*)?',
                '/link(\\/.*)?',
                '/payment(\\/.*)?',
                '/user(\\/.*)?',
                '/messagecenter(\\/.*)?'
            ].join('|') +
            ')$'
        );

        if (allowedRouteRegex.test(hashPath)) {
            // remove any trailing '/#' from the pathname (e.g. '/#' -> '/')
            const cleanBase = window.location.pathname.replace(/\/#$/, '');
            // build a clean URL and use that
            const cleanUrl = cleanBase.replace(/\/$/, '') + hashPath + query;
            window.history.replaceState(null, '', cleanUrl);
        } else {
            window.history.replaceState(null, '', '/');
        }
    }
})();


initSentry();

const container = document.getElementById('root');
const root = createRoot(container);
root.render(<Main />);
